export const POPUP_TYPES = {
    ActionStatus : 'active_status'
}